export enum ClinicStatus {
  All = 'all',
  Active = 'active',
  Inactive = 'inactive',
  Delinquent = 'delinquent',
}
